<template>
  <modal title="Message Templates" height="430px" >
    <template v-if="!template">
      <b-list-group>
        <b-list-group-item v-for="t in templates" :key="t.id" class="d-flex justify-content-between align-items-center cursor-pointer pr-0" @click="template = t">
          <div>
            <h6>{{ t.name }}</h6>
            <div class="text-muted font overflow-hidden text-overflow-ellipsis" style="height: 40px">{{
                t.content
              }}
            </div>
          </div>
          <div class="ml-2 mr-0 d-flex">
            <b-btn variant="link" :class="t.default_template ? 'text-primary' : 'text-secondary'" @click.stop="make_default(t)">
              <font-awesome-icon :icon="[t.default_template ? 'fas' : 'far', 'star']" />
            </b-btn>
            <b-btn class="ml-0 text-danger" variant="link" @click.stop="delete_template(t)">
              <font-awesome-icon :icon="['far', 'trash-can']" />
            </b-btn>
          </div>
        </b-list-group-item>
      </b-list-group>
    </template>

    <div class="d-flex flex-column h-100" v-else>
      <modal-row label="Name">
        <b-form-input v-model="template.name" />
      </modal-row>
      <modal-row label="Fields">
        <span class="mr-2 mt-2" v-for="f in fields" :key="f">{{ f }}</span>
      </modal-row>
      <b-textarea class="mt-4 flex-fill" v-model="template.content" />
    </div>

    <template #footer>
      <template v-if="!!template">
      <b-button variant="outline-danger" size="sm" class="px-3 mr-3" @click="template = null" v-if="template">Cancel</b-button>
      <b-button variant="primary" size="sm" class="px-3" @click="save" v-if="template">Save</b-button>
      </template>
      <b-button v-else variant="outline-primary" size="sm" class="px-3" @click="template = {}">New Template</b-button>
    </template>
  </modal>
</template>

<script>
export default {
  name: "message-templates",
  data() {
    return {
      template: null,
      templates: [],
      fields: []
    }
  },
  mounted() {
    this.refresh()
    this.asyncAction('/api/message/template/fields', 'get').then(v => this.fields = v)
  },
  methods: {
    async make_default(t) {
      if (t.default_template)
        return

      await this.asyncAction(t._links.self_url.href, 'PUT', {data: {default_template: true }})
      this.refresh(true)

      this.toast('Template now default')
    },

    async refresh(quiet) {
      this.templates = await this.asyncAction('/api/message/template?content=true', 'GET', { quiet })
    },
    async delete_template(t) {
      if (! await this.confirm('Delete this template?'))
        return

      await this.asyncAction(t._links.delete_url.href, t._links.delete_url.method)
      await this.refresh(true)
      this.toast('Message template deleted')
    },
    async save() {
      const data = {
        name: this.template.name,
        content: this.template.content,
        default: this.template.default
      }
      if (this.template._links) {
        await this.asyncAction(this.template._links.self_url.href, 'PUT', {
          data
        })
        this.toast('Message template modified')
      } else {
        await this.asyncAction('/api/message/template', 'POST', {
          data
        })
        this.toast('Message template created')
      }

      this.refresh(true)
      this.template = null
    }
  }
}
</script>

<style scoped>

</style>